import SummaryItem from '../SummaryItem';
import { MainText, SubText } from '../primitives';

interface HotelInfoProps {
  name: string;
  address: string;
}

const HotelInfo = ({ name, address }: HotelInfoProps) => (
  <SummaryItem icon="place" label="Hotel">
    <MainText fontSize={['lg', 'lg']}>{name}</MainText>
    <SubText>{address}</SubText>
  </SummaryItem>
);

export default HotelInfo;
